module.exports = __webpack_public_path__ + "img/list-logo.5bef214b.webp";